export default "__VITE_ASSET__40fc3f6c__"